// src/api/paperTrade.js
import axios from "axios";

const API_BASE = "/paper-trade";

export async function enterPaperTrade({ symbol, entryPrice, compositeScore, valueScore, qualityScore, momentumScore, notes }) {
  const response = await axios.post(`${API_BASE}/enter`, {
    symbol,
    entry_price: entryPrice,
    composite_score: compositeScore,
    value_score: valueScore ?? 0,
    quality_score: qualityScore ?? 0,
    momentum_score: momentumScore ?? 0,
    notes: notes ?? "",
  });
  return response.data;
}

export async function listPaperPositions(filter) {
  const params = filter ? { filter } : {};
  const response = await axios.get(`${API_BASE}/positions`, { params });
  return response.data;
}

export async function closePaperTrade(tradeId, exitPrice) {
  const response = await axios.post(`${API_BASE}/close/${tradeId}`, { exit_price: exitPrice });
  return response.data;
}

export async function getPaperPnL() {
  const response = await axios.get(`${API_BASE}/pnl`);
  return response.data;
}

